import React from "react";
import ReactDOM from "react-dom/client";
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-icons/font/bootstrap-icons.css";
import "./style/index.scss";
import "react-image-gallery/styles/scss/image-gallery.scss";
import { App } from "./App";
import { initInstallPromptCapture } from "./utils/installPrompt";
import { registerServiceWorker } from "./registerServiceWorker";
import { initClientAlertMonitoring } from "./services/clientAlert";

if (typeof window !== "undefined") {
  initInstallPromptCapture();
  initClientAlertMonitoring();
  registerServiceWorker();
}

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement,
);
document.getElementsByTagName("body")[0].style.height = 100 + 'vlh';
// document.getElementsByTagName("body")[0].style.background =  "red";


root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();
